import React from 'react';

export default function DailySection({
  displayDateStr,
  moveDailyDate,
  moveTodayDailyDate,
  selectedDayWorkoutsDetail,
  selectedDayCardioDetail,
  selectedDaySummary,
  prevDaySummary,
  renderDiff,
  handleCopyDailyWorkout,
  handleEvaluateDailyWorkout
}) {
  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="bg-slate-900 rounded-3xl p-6 text-white shadow-xl relative overflow-hidden">
        <div className="absolute -right-6 -top-6 w-24 h-24 bg-indigo-600/10 rounded-full blur-xl"></div>
        <div className="flex justify-between items-start">
          <div>
            <p className="text-[10px] font-black text-indigo-400 tracking-wider uppercase bg-slate-800 px-2.5 py-1 rounded-md inline-block">Daily Dashboard</p>
            <h3 className="mt-2 text-xl font-black tracking-tight text-white">운동 루틴</h3>
            <div className="flex items-center gap-2 mt-3">
              <button onClick={() => moveDailyDate(-1)} className="p-1.5 bg-slate-800 hover:bg-slate-700 rounded-lg text-slate-300 transition-colors">
                <span className="material-icons-round text-sm">chevron_left</span>
              </button>
              <p className="text-m text-slate-400 font-medium">{displayDateStr}</p>
              <button onClick={() => moveDailyDate(1)} className="p-1.5 bg-slate-800 hover:bg-slate-700 rounded-lg text-slate-300 transition-colors">
                <span className="material-icons-round text-sm">chevron_right</span>
              </button>
              <button onClick={() => moveTodayDailyDate()} className="p-1.5 bg-slate-800 hover:bg-slate-700 rounded-lg text-slate-300 transition-colors">
                <span className="material-icons-round text-sm">refresh</span>
              </button>
            </div>
          </div>
          <div className="text-right">
            <span className="material-icons-round text-3xl text-indigo-500">task_alt</span>
          </div>
        </div>
        
        {(selectedDayWorkoutsDetail.length > 0 || selectedDayCardioDetail.length > 0) && (
          <div className="flex gap-2 mt-5 pt-4 border-t border-slate-800">
            <div className="bg-slate-800/80 px-3 py-2 rounded-xl flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-indigo-400"></span>
              <span className="text-[11px] font-bold text-slate-300">무산소 {selectedDayWorkoutsDetail.length}개 종목</span>
            </div>
            <div className="bg-slate-800/80 px-3 py-2 rounded-xl flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-teal-400"></span>
              <span className="text-[11px] font-bold text-slate-300">유산소 {selectedDayCardioDetail.length}개 종목</span>
            </div>
          </div>
        )}
      </div>

      {selectedDayWorkoutsDetail.length > 0 && (
        <div className="bg-white rounded-3xl p-5 border border-slate-200 shadow-sm animate-slideUp">
          <h4 className="text-[11px] font-black text-slate-500 mb-4 flex items-center gap-1 uppercase tracking-wider">
            <span className="material-icons-round text-sm">insights</span>최근 증감 요약
          </h4>
          <div className="grid grid-cols-3 divide-x divide-slate-100 text-center">
            <div>
              <p className="text-[10px] font-bold text-slate-400 mb-1">최고 중량</p>
              <div className="flex items-center justify-center">
                <span className="text-sm font-black text-slate-800">{selectedDaySummary.maxWeight}kg</span>
                {renderDiff(selectedDaySummary.maxWeight, prevDaySummary.maxWeight, 'kg')}
              </div>
            </div>
            <div>
              <p className="text-[10px] font-bold text-slate-400 mb-1">총 세트</p>
              <div className="flex items-center justify-center">
                <span className="text-sm font-black text-slate-800">{selectedDaySummary.setsCount}</span>
                {renderDiff(selectedDaySummary.setsCount, prevDaySummary.setsCount, '세트')}
              </div>
            </div>
            <div>
              <p className="text-[10px] font-bold text-slate-400 mb-1">총 횟수</p>
              <div className="flex items-center justify-center">
                <span className="text-sm font-black text-slate-800">{selectedDaySummary.totalReps}</span>
                {renderDiff(selectedDaySummary.totalReps, prevDaySummary.totalReps, '회')}
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedDayWorkoutsDetail.length === 0 && selectedDayCardioDetail.length === 0 ? (
        <div className="p-12 text-center flex flex-col items-center justify-center bg-slate-50/50 rounded-3xl border-2 border-dashed border-slate-200">
          <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center shadow-sm mb-4 border border-slate-100">
            <span className="material-icons-round text-2xl text-slate-400">fitness_center</span>
          </div>
          <p className="text-sm font-black text-slate-700">해당 날짜에 완료한 운동이 없어요</p>
          <p className="text-[11px] text-slate-400 mt-1.5 max-w-[200px] leading-relaxed">
            다른 날짜를 선택하여 조회하거나, '기록' 탭으로 이동하여 운동을 기록해 보세요.
          </p>
        </div>
      ) : (
        <div className="space-y-6">
          {selectedDayWorkoutsDetail.length > 0 && (
            <div className="space-y-3">
              <h4 className="text-xs font-black text-indigo-600 uppercase tracking-wider px-1">무산소 운동</h4>
              <div className="relative pl-4 ml-2 border-l-2 border-indigo-100 space-y-4">
                {selectedDayWorkoutsDetail.map((workout, index) => (
                  <div key={index} className="relative group animate-slideUp">
                    <span className="absolute -left-[23px] top-4 w-3 h-3 rounded-full bg-indigo-600 border-4 border-white shadow-sm ring-4 ring-indigo-50"></span>
                    <div className="bg-white rounded-2xl p-4 border border-slate-100 shadow-sm flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-11 h-11 bg-indigo-50 text-indigo-600 rounded-xl flex items-center justify-center border border-indigo-100">
                          <span className="material-icons-round text-lg">fitness_center</span>
                        </div>
                        <div>
                          <h4 className="font-black text-sm text-slate-800 tracking-tight">{workout.name}</h4>
                          <div className="flex items-center gap-1.5 mt-1">
                            <span className="text-[10px] font-extrabold text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded-md">{workout.setsCount} Sets</span>
                            <span className="text-[10px] font-medium text-slate-400">총 {workout.totalReps}회</span>
                          </div>
                        </div>
                      </div>
                      <div className="text-right bg-slate-50 px-3 py-2 rounded-xl border border-slate-100 min-w-[75px]">
                        <span className="block text-[9px] font-bold text-slate-400 uppercase">Max Weight</span>
                        <span className="text-sm font-black text-slate-800 mt-1 inline-block">{workout.maxWeight}<span className="text-[10px] text-slate-500 ml-0.5">kg</span></span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {selectedDayCardioDetail.length > 0 && (
            <div className="space-y-3">
              <h4 className="text-xs font-black text-teal-600 uppercase tracking-wider px-1">유산소 운동</h4>
              <div className="relative pl-4 ml-2 border-l-2 border-teal-100 space-y-4">
                {selectedDayCardioDetail.map((workout, index) => (
                  <div key={index} className="relative group animate-slideUp">
                    <span className="absolute -left-[23px] top-4 w-3 h-3 rounded-full bg-teal-600 border-4 border-white shadow-sm ring-4 ring-teal-50"></span>
                    <div className="bg-white rounded-2xl p-4 border border-slate-100 shadow-sm flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-11 h-11 bg-teal-50 text-teal-600 rounded-xl flex items-center justify-center border border-teal-100">
                          <span className="material-icons-round text-lg">directions_run</span>
                        </div>
                        <div>
                          <h4 className="font-black text-sm text-slate-800 tracking-tight">{workout.name}</h4>
                          <div className="flex items-center gap-1.5 mt-1">
                            <span className="text-[10px] font-extrabold text-teal-600 bg-teal-50 px-2 py-0.5 rounded-md">{workout.setsCount} Sets</span>
                          </div>
                        </div>
                      </div>
                      <div className="text-right bg-slate-50 px-3 py-2 rounded-xl border border-slate-100 min-w-[75px]">
                        <span className="block text-[9px] font-bold text-slate-400 uppercase">Total</span>
                        <span className="text-sm font-black text-slate-800 mt-1 inline-block">
                          {workout.totalTime > 0 ? `${workout.totalTime}분 ` : ''}
                          {workout.totalDistance > 0 ? `${workout.totalDistance}km` : ''}
                          {workout.totalTime === 0 && workout.totalDistance === 0 ? '-' : ''}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {(selectedDayWorkoutsDetail.length > 0 || selectedDayCardioDetail.length > 0) && (
        <button
          onClick={handleCopyDailyWorkout}
          className="w-full mt-8 h-16 bg-slate-800 text-white rounded-2xl font-bold flex items-center justify-center gap-2 shadow-xl shadow-slate-200 hover:bg-slate-700 transition-colors"
        >
          <span className="material-icons-round text-xl">content_copy</span>
          운동 기록 복사
        </button>
      )}

      {(selectedDayWorkoutsDetail.length > 0 || selectedDayCardioDetail.length > 0) && (
        <div>
          <button
            onClick={handleEvaluateDailyWorkout}
            className="w-full mt-3 h-16 bg-blue-600 text-white rounded-2xl font-bold flex items-center justify-center gap-2 shadow-xl shadow-blue-200 hover:bg-blue-700 transition-colors"
          >
            <span className="material-icons-round text-xl">smart_toy</span>
            운동 기록 평가
          </button>
          <span className='flex items-center justify-center mt-4 text-sm text-slate-400'>최근(전 날) 운동 기록과 신체 정보, 영양제 정보까지 포함합니다.</span>
          <span className='flex items-center justify-center mt-4 text-sm font-bold'>분석 결과가 성장 기록에 측정됩니다!</span>
        </div>
      )}
    </div>
  );
}